module.exports = __webpack_public_path__ + "img/4d343acea98b8ba40f31f6f854c7282c.png";